module.exports = __webpack_public_path__ + "static/sauna-ab38650f76c489708749acdfbca9551b.jpeg";